<template>
  <div class="km-about">
    <div class="section-header">
      <div class="section-tag">About Us</div>
      <h2 class="section-title">公司介绍</h2>
      <p class="section-desc">专注自动化设备制造，引领行业发展</p>
    </div>

    <div class="about-content">
      <div class="about-images">
        <div class="about-img-main">
          <img src="/assets/about1.jpg" alt="公司生产环境" />
        </div>
        <div class="about-img-secondary">
          <img src="/assets/about2.jpg" alt="公司设备展示" />
        </div>
      </div>

      <div class="about-info">
        <div class="about-highlight">
          <Icon type="ios-information-circle" size="22" class="highlight-icon" />
          <span>关于我们</span>
        </div>
        <h3 class="about-headline">宁国市柯美自动化设备制造有限公司</h3>
        <p class="about-text">
          宁国市柯美自动化设备制造公司是一家从事机械设计、制造、加工的企业。承接各类自动化设备、工装、零件的开发及制造，公司在机械设计、电气控制、液压系统、气动系统等技术领域具有超强的设计能力。
        </p>
        <p class="about-text">本着追求卓越，精益求精的精神；质量第一、信誉至上、以质量示发展为宗旨，热诚欢迎海内外人士来函指导或洽淡业务。</p>

        <div class="about-features">
          <div class="feature-item" v-for="feat in features" :key="feat.label">
            <div class="feature-icon">
              <Icon :type="feat.icon" size="20" />
            </div>
            <div class="feature-text">
              <strong>{{ feat.label }}</strong>
              <span>{{ feat.desc }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      features: [
        { icon: 'ios-construct', label: '机械设计', desc: '专业的机械设计与制造能力' },
        { icon: 'ios-flash', label: '电气控制', desc: '先进的电气控制系统设计' },
        { icon: 'ios-settings', label: '液压气动', desc: '液压系统与气动系统专家' },
        { icon: 'ios-ribbon', label: '品质保证', desc: '质量第一，信誉至上' },
      ],
    };
  },
};
</script>

<style scoped lang="less">
.km-about {
  width: 100%;
}

/* 内容区 */
.about-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
  align-items: center;
}

/* 图片区域 */
.about-images {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 12px;
  height: 360px;
}

.about-img-main,
.about-img-secondary {
  border-radius: 10px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;

    &:hover {
      transform: scale(1.04);
    }
  }
}

.about-img-main {
  box-shadow: var(--shadow-md);
}

.about-img-secondary {
  box-shadow: var(--shadow-sm);
}

/* 文字区域 */
.about-info {
  display: flex;
  flex-direction: column;
}

.about-highlight {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--accent);
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 12px;

  .highlight-icon {
    color: var(--accent);
  }
}

.about-headline {
  font-size: 22px;
  font-weight: 700;
  color: var(--primary);
  margin: 0 0 20px;
  line-height: 1.4;
}

.about-text {
  font-size: 15px;
  line-height: 1.8;
  color: var(--text-secondary);
  margin: 0 0 14px;
}

/* 特色功能 */
.about-features {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 24px;
}

.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px;
  background: var(--bg-secondary);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-color);
}

.feature-icon {
  width: 36px;
  height: 36px;
  background: var(--primary-bg);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--primary);
}

.feature-text {
  display: flex;
  flex-direction: column;
  gap: 2px;

  strong {
    font-size: 13px;
    font-weight: 600;
    color: var(--text-primary);
  }

  span {
    font-size: 12px;
    color: var(--text-muted);
    line-height: 1.4;
  }
}

/* 响应式 */
@media (max-width: 1024px) {
  .about-content {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .about-images {
    height: 280px;
  }
}

@media (max-width: 768px) {
  .about-images {
    grid-template-columns: 1fr;
    height: auto;
  }

  .about-img-main {
    height: 220px;
  }

  .about-img-secondary {
    display: none;
  }

  .about-features {
    grid-template-columns: 1fr;
    gap: 10px;
  }
}

@media (max-width: 480px) {
  .about-headline {
    font-size: 18px;
  }
  .about-text {
    font-size: 14px;
  }
}
</style>
